<template>
  <div class="detail-info">
    <!--审批状态 icon-->
    <el-card-title
      title="基本信息"
      class="detail-info-form-title"
    ></el-card-title>
    <div class="detail-info-form-container" style="background: #fff">
      <detail-info-form
        :detailData="baseInfoFormItem"
        :detailGetData="baseInfoData"
      ></detail-info-form>
    </div>
    <el-card-title
      title="法定代表人"
      class="detail-info-form-title"
      style="margin: 0; padding: 0 20px; background: #fff"
    ></el-card-title>
    <div class="detail-info-form-container" style="background: #fff">
      <detail-info-form
        :detailGetData="representativeData"
        :detailData="representativeFormItem"
      ></detail-info-form>
    </div>
    <el-card-title
      title="财务信息"
      class="detail-info-form-title"
      style="margin: 0; padding: 0 20px; background: #fff"
    ></el-card-title>
    <div class="detail-info-form-container" style="background: #fff">
      <detail-info-form
        :detailGetData="financeInfoData"
        :detailData="financeInfoFormItem"
      ></detail-info-form>
    </div>
    <el-card-title
      title="产品信息"
      class="detail-info-table-title"
      style="margin: 0; padding: 0 20px; background: #fff"
    ></el-card-title>
    <div class="detail-info-table-container" style="background: #fff">
      <detail-info-table
        :tableData="productData"
        :tableColumn="productColumn"
        max-height="419"
        :border-style="2"
      ></detail-info-table>
    </div>
    <!-- 产品说明 -->
    <template
      v-if="
        this.productsInfoData.mainType === 0 ||
        this.productsInfoData.mainType === 1
      "
    >
      <el-card-title
        title="产品说明"
        class="detail-info-form-title"
        style="margin: 0; padding: 0 20px; background: #fff"
      ></el-card-title>
      <div class="detail-info-form-container" style="background: #fff">
        <detail-info-form
          :detailGetData="productsInfoData"
          :detailData="productsInfoFormItem"
          labelWidth="230px"
        ></detail-info-form>
      </div>
    </template>
    <el-card-title
      title="合作业绩"
      class="detail-info-form-title"
      style="margin: 0; padding: 0 20px; background: #fff"
    ></el-card-title>
    <div class="detail-info-form-container" style="background: #fff">
      <detail-info-form
        :detailGetData="enterpriseData"
        :detailData="enterpriseFormData"
        max-height="419"
        :border-style="2"
      ></detail-info-form>
    </div>
    <el-card-title
      title="资质文件"
      class="detail-info-file-list-title"
      style="margin: 0; padding: 0 20px; background: #fff"
    ></el-card-title>
    <div style="height: 20px; background: #fff"></div>
    <detailInfoFileList
      :info="shopAptitudeInfo"
      @downloadFile="downloadFile"
    ></detailInfoFileList>
    <div style="height: 20px; background: #f1f1f1"></div>
    <div
      ref="footerBtn"
      class="footer-return"
      style="padding-bottom: 20px; background: #f1f1f1"
    >
      <div class="step-return" @click="crumbsBack">返回</div>
    </div>
  </div>
</template>

<script>
import detailInfoForm from "./detail-info-form";
import detailInfoTable from "./detail-info-table";
import detailInfoFileList from "./detail-info-file-list";
import { queryInfoCheckDetail } from "@/api/register";
// import { mixinCommon } from "./mixin-template/mixin-common";
import imgBase64 from "@/utils/img-base64";
export default {
  // mixins: [mixinCommon],
  name: "detailInfo",
  components: {
    detailInfoForm,
    detailInfoTable,
    detailInfoFileList,
  },
  data() {
    return {
      supplierCode: "",
      // 基本信息相关数据
      baseInfoData: {},
      baseInfoFormItem: [
        {
          label: "单位名称（中文）",
          value: "supplierChineseName",
        },
        {
          label: "单位名称（英文）",
          value: "supplierEnglishName",
        },
        {
          label: "单位简称",
          value: "supplierShortname",
        },
        {
          label: "统一社会信用代码",
          value: "unifiedCode",
        },
        {
          label: "工商注册号",
          value: "regNum",
        },
        {
          label: "组织机构代码",
          value: "orgCode",
        },
        {
          label: "纳税人识别号",
          value: "taxCode",
        },
        {
          label: "纳税人类型",
          value: "taxpayerName",
        },
        {
          label: "住所",
          value: "address",
        },
        {
          label: "公司类型",
          value: "compTypeName",
          error: "flag",
        },
        {
          label: "成立日期",
          value: "foundTime",
        },
        {
          label: "注册资本（万元）",
          value: "regCapl",
        },
        {
          label: "实收资本（万元）",
          value: "factCapl",
        },
        {
          label: "经营范围",
          value: "supplierScope",
        },
        {
          label: "单位类别",
          value: "compClassName",
        },
        {
          label: "所在区域",
          value: "locationName",
        },
        {
          label: "办公地址",
          value: "officeAddress",
        },
        {
          label: "币种",
          value: "coinName",
        },
        {
          label: "邮编",
          value: "post",
        },
        {
          label: "上年营业额（万元）",
          value: "lastYearTurnover",
        },
        {
          label: "员工人数",
          value: "employeeNum",
        },
        {
          label: "是否外贸分包商",
          value: "isForeignTrade",
        },
        {
          label: "所属集团公司名称",
          value: "upSupplierName",
        },
        {
          label: "公司网址",
          value: "website",
        },
        {
          label: "公司简介",
          value: "corpDesc",
        },
        {
          label: "组织架构及营销网络",
          value: "orgDesc",
        },
        {
          label: "联系人",
          value: "regNameNumber",
        },
      ],
      // 法定代表人相关数据
      representativeData: {},
      representativeFormItem: [
        {
          label: "姓名",
          value: "contactName",
        },
        {
          label: "证件类型",
          value: "idTypeName",
        },
        {
          label: "证件号码",
          value: "idNumber",
        },
        {
          label: "手机号码",
          value: "contactMobile",
        },
        {
          label: "固定电话",
          value: "contactTel",
        },
      ],
      // 财务信息
      financeInfoData: {},
      financeInfoFormItem: [
        {
          label: "开户银行",
          value: "bankName",
        },
        {
          label: "银行账号",
          value: "bankId",
        },
        {
          label: "开票地址",
          value: "billingAddress",
        },
        {
          label: "开票电话",
          value: "billingTelephone",
        },
      ],
      // 服务范围相关数据
      productData: [],
      productColumn: [
        {
          prop: "productCode",
          label: "产品（服务）编码",
        },
        {
          prop: "productName",
          label: "产品（服务）名称",
        },
        {
          prop: "productBrand",
          label: "厂商或品牌",
        },
        {
          prop: "productRemark",
          label: "备注",
        },
        //   {
        //     prop: "certificationDate",
        //     label: "认证时间"
        //   },
        //   {
        //     prop: "serviceStatus",
        //     label: "服务状态"
        //   }
      ],
      // 合作业绩相关数据
      enterpriseData: {},
      enterpriseFormData: [
        {
          label: "与同类行业企业合作业绩",
          value: "similarEnterprise",
        },
        {
          label: "合作企业",
          value: "coEnterprise",
        },
        {
          label: "与中交合作业绩",
          value: "coHistory",
        },
        {
          label: "备注",
          value: "remark",
        },
      ],
      // 产品说明 mainType;//主类 0 物资 1装备 2分包
      productsInfoData: {},
      productsInfoFormItem: [
        {
          label: "产能",
          value: "capacity",
        },
        {
          label: "工艺技术现状",
          value: "techDesc",
        },
        {
          label: "所代理生产商名称",
          value: "agentProd",
        },
        {
          label: "经销代理资格",
          value: "agentQual",
        },
      ],
      // 资质文件相关数据
      shopAptitudeInfo: [],
    };
  },
  created() {
    if (sessionStorage.getItem("querySupplierCode")) {
      let codeObj = JSON.parse(sessionStorage.getItem("querySupplierCode"));
      this.supplierCode = codeObj.supplierCode;
      queryInfoCheckDetail({ supplierCode: this.supplierCode }).then((res) => {
        console.log(res);
        let fileType = [
          { type: "xls,xlsx", base64: imgBase64.xls },
          { type: "doc,docx", base64: imgBase64.doc },
          { type: "zip,rar", base64: imgBase64.zip },
          { type: "txt", base64: imgBase64.txt },
          { type: "pdf", base64: imgBase64.pdf },
        ];
        this.baseInfoData = res.data.data.info;
        // this.baseInfoData.regName = "张三";
        // this.baseInfoData.regMobile = "13144554242";
        if (this.baseInfoData.regName && this.baseInfoData.regMobile) {
          this.baseInfoData["regNameNumber"] =
            this.baseInfoData.regName +
            "（" +
            this.baseInfoData.regMobile +
            "）";
        }
        this.baseInfoData.isForeignTrade =
          this.baseInfoData.isForeignTrade === 0 ? "否" : "是";
        this.representativeData = res.data.data.contactBO;
        this.financeInfoData = res.data.data.finance;
        this.productData = res.data.data.products;
        this.enterpriseData = res.data.data.enterprise;
        this.productsInfoData = res.data.data.info;

        this.shopAptitudeInfo = res.data.data.files.map((item) => {
          return {
            aptitudeUrl: item.fileAddress,
            aptitudeName: item.fileName,
            fileClassName: item.fileClassName,
            networkAddress: item.website,
            effectBeginTime: item.validityStart,
            effectEndTime: item.validityEnd,
            uploadId: item.uploadId,
            fileType: item.fileType,
          };
        });

        this.shopAptitudeInfo.forEach((item) => {
          let urlFileTypeArr = item.aptitudeUrl.split("?")[0].split(".");
          let urlFileType = urlFileTypeArr[urlFileTypeArr.length - 1];
          fileType.forEach((itemBase) => {
            if (itemBase.type.includes(urlFileType.toLowerCase())) {
              item.aptitudeUrl = itemBase.base64;
              item.isBase64 = true;
            }
          });
        });
      });
    }
  },
  mounted() {
    if (!!window.ActiveXObject || "ActiveXObject" in window)
      this.$refs.footerBtn.style.padding = "0 0 20px 0";
    else {
      console.log("no");
    }
  },
  methods: {
    downloadFile(uploadId) {
      window.open(
        `${location.origin}/apis/asca/file/download?uploadId=${uploadId}&agentId=${this.businessParams.agentId}`
      );
    },
    crumbsBack() {
      this.$emit("crumbsBack");
    },
  },
};
</script>

<style scoped lang="scss">
.detail-info {
  background: #fff;
  width: 100%;
  // min-height: calc(100vh - 260px);
  float: left;
  position: relative;
  // padding-bottom: 17px;
  line-height: normal !important;
  text-align: left;
  // margin-bottom: 20px;
  /deep/.el-form-item__content {
    line-height: 30px !important;
    height: 30px;
  }
  /deep/.table-body
    .el-table
    .el-table__body-wrapper
    .el-table__body
    tr
    td
    .cell {
    height: 36px;
    line-height: 36px;
  }
  .detail-info-form-title-custom {
    position: relative;
    i {
      position: absolute;
      left: 84px;
      top: 14px;
      color: #ff0037;
      cursor: pointer;
    }
    .detail-info-form-title-suffix {
      float: right;
      height: 40px;
      line-height: 40px;
      font-size: 13px;
      margin-right: 32px;
      span {
        font-size: 20px;
        color: #ff0037;
        font-weight: 600;
      }
    }
  }
  .detail-info-form-title {
    margin-bottom: 5px;
  }
  .detail-info-table-title {
    margin-bottom: 13px;
  }
  .detail-info-file-list-title {
    margin-bottom: -3px;
    background: #fff;
  }
  .detail-info-el-Label {
    position: absolute;
    width: 107px;
    right: 33px;
    top: 31px;
    z-index: 1;
  }
  .detail-info-form-container {
    padding: 0 20px;
    background: #fff;
  }
  .detail-info-table-container {
    padding: 0 20px;
    margin-top: 8px;
    .detail-info-table-link {
      color: #ff0037;
    }
  }
  .detail-info-history-list {
    margin: 15px 0 20px 20px;
  }
  //底部上一步下一步
  .footer-return {
    display: flex;
    justify-content: center;
    div {
      width: 400px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #ff142f;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      user-select: none;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFangSC;
      color: #fff;
    }
  }
}
</style>
